import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ContactRound, KeyRound } from 'lucide-react'
import { tr } from 'i18n'
import { hasAccess } from 'utils/access'
import { changeGuardInn, resetGuardPin } from 'service/AdminPanelService'
import { getErpErrorMessage } from 'service/ErpService'
import GuardAccountDialog from '../GuardAccountDialog/GuardAccountDialog.tsx'
import styles from '../AdminPanelPage.module.scss'
import s from '../Management.module.scss'

export default function GuardAccountActions({ guard, onChanged = () => {} }) {
  useTranslation()
  const user = useSelector(state => state.user)
  const [mode, setMode] = useState('')
  const [busy, setBusy] = useState(false)
  const busyRef = useRef(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const canReset = hasAccess(user, 'guards_pin')
  const canChangeInn = hasAccess(user, 'guards_inn')
  if (user?.is_report_only || guard.employee === null || (!canReset && !canChangeInn)) return null

  const open = action => { setError(''); setMessage(''); setMode(action) }
  const confirm = async (inn, pin) => {
    if (busyRef.current || !mode || !/^[0-9]{4}$/.test(pin) || (mode === 'inn' && !/^[0-9]{14}$/.test(inn))) return
    if (mode === 'inn' ? !canChangeInn : !canReset) return
    busyRef.current = true
    setBusy(true); setError(''); setMessage('')
    try {
      if (mode === 'inn') await changeGuardInn(guard.id, inn, pin)
      else await resetGuardPin(guard.id, pin)
      setMode('')
      setMessage(tr(mode === 'inn' ? 'ИНН обновлён. Для входа используйте новый ИНН.' : 'PIN сброшен. При следующем входе охранник задаст новый код.'))
      await onChanged()
    } catch (failure) {
      setError(getErpErrorMessage(failure, tr(mode === 'inn' ? 'Не удалось изменить ИНН охранника.' : 'Не удалось сбросить PIN охранника.')))
    } finally {
      busyRef.current = false
      setBusy(false)
    }
  }
  return <div onClick={event => event.stopPropagation()}>
    <div className={styles.actionGroup}>
      {canReset && <button type="button" className={styles.smallBtn} disabled={busy} aria-haspopup="dialog" aria-expanded={mode === 'pin'} onClick={() => open('pin')}>
        <KeyRound size={14} aria-hidden="true" />{tr('Сбросить PIN')}
      </button>}
      {canChangeInn && <button type="button" className={styles.smallBtn} disabled={busy} aria-haspopup="dialog" aria-expanded={mode === 'inn'} onClick={() => open('inn')}>
        <ContactRound size={14} aria-hidden="true" />{tr('Сменить ИНН')}
      </button>}
    </div>
    {message && <p role="status" className={s.muted}>{message}</p>}
    {error && !mode && <p role="alert" className={s.error}>{error}</p>}
    {mode && <GuardAccountDialog key={mode} name={guard.employee_name || ''} currentInn={guard.inn || ''} mode={mode}
      busy={busy} error={error} onConfirm={confirm} onClose={() => { if (!busyRef.current) setMode('') }} />}
  </div>
}
